import { useEffect, useState } from "react";
import { getChartsData } from "../api";

export const useChartsData = (code) => {
  const [indicators_groups, setIndicatorsGroups] = useState([]);
  const [indicators_map, setIndicatorsMap] = useState([]);
  // Backend-computed permission set for the signed-in user's role
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) return;

    getChartsData(code)
      .then((res) => {
        setIndicatorsGroups(res.data.indicators_groups);
        setIndicatorsMap(res.data.indicators_map);
        setPermissions(res.data.permissions || {});
      })
      .finally(() => setLoading(false));
  }, [code]);

  return { indicators_groups, indicators_map, permissions, loading };
};
